import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, Teleport as _Teleport, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49c35442"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bottom-sheet" }
const _hoisted_2 = { class: "bottom-sheet__content" }


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseBottomSheet',
  props: {
    sheet: { type: Boolean },
    closeOutside: { type: Boolean }
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
const closeSheet = () => {
  emit('close');
};

return (_ctx: any,_cache: any) => {
  const _component_base_icon = _resolveComponent("base-icon")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_ctx.sheet)
    ? (_openBlock(), _createBlock(_Teleport, {
        key: 0,
        to: "#modalWindow"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "default"),
            _createVNode(_component_base_icon, {
              class: "bottom-sheet__content-closeIcon",
              name: "close",
              clickable: "",
              height: "15",
              width: "15",
              onClick: closeSheet
            })
          ])), [
            [_directive_click_outside, _ctx.closeOutside ? closeSheet : () => {}]
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})